import { postHandler } from "../../utils/asyncHandler";
import API_CONFIG from "../../config/apiConfig";
import { getCompanyUuid } from "../../utils/getCompanyUuid";

export const employeeSearch = async (
  payload = {
    data: {
      info: {}
    }
  }
) => {
  try {
    const companyUuid = getCompanyUuid();
    if (!companyUuid) {
      return null;
    }
    const endpoint = API_CONFIG.employee.search(companyUuid);
    const res = await postHandler(endpoint, payload);
    return res?.data?.info ?? null;
  } catch (error) {
    return null;
  }
};

export const customerEmployeeSearch = async (
  payload = {
    data: {
      info: {}
    }
  }
) => {
  const companyUuid = getCompanyUuid();
  if (!companyUuid) {
    return null;
  }
  const endpoint = API_CONFIG.customerEmployee.list(companyUuid);
  const res = await postHandler(endpoint, payload);
  return res?.data;
};
